module.exports = __webpack_public_path__ + "img/baitian0.166d8c36.png";